export default __webpack_public_path__ + "static/media/yellow.88a53c30.svg";